import { parseQueryParams } from 'modules/main/utils';

export const parseLongTailQuery = (query?: string) => {
  const parsedQuery = new URLSearchParams(query);
  const updatedQuery = new URLSearchParams();

  parsedQuery.forEach((value, key) => {
    if (key === 'fss') {
      updatedQuery.append('query', value);
    } else {
      updatedQuery.append('filter', `${key}:${value}`);
    }
  });
  return updatedQuery;
};

export const parseSearchQuery = (
  requestQuery?: URLSearchParams,
  configQuery?: string,
) => {
  const nextQueryParams = new URLSearchParams(requestQuery);

  if (configQuery) {
    const queryFromConfig = new URLSearchParams(configQuery);

    // fss - query using on searchPage
    queryFromConfig.append('headline', queryFromConfig.get('fss') || '');
    queryFromConfig.delete('fss');

    const parsedQuery = parseQueryParams(Object.fromEntries(queryFromConfig));

    // add query params from searchQuery to requestQuery
    parsedQuery.forEach((value, key) => {
      nextQueryParams.append(key, value);
    });
  }

  return nextQueryParams;
};
